// extracted by mini-css-extract-plugin
module.exports = {"userImage":"ChatGroupItemImage_userImage__3Wb-P"};